import { atom, swr } from '@exodus/headless-ui';
import prefillIdAtom from './prefill-id.js';
import prefillsAtom from './prefills.js';
import fromAssetAtom from './from-asset.js';
import swapModeAtom from './swap-mode.js';
import slippageAtom from './slippage.js';
import fromSpendableBalanceAtom from './from-spendable-balance.js';
import feeAmountAtom from './fee-amount.js';
const fromTotalBalanceAtom = atom((get) => {
    const prefillId = get(prefillIdAtom);
    const prefills = get(swr(prefillsAtom));
    const spendableBalance = get(fromSpendableBalanceAtom);
    if (prefillId === 'max') {
        const max = prefills.data?.max;
        const isAll = max?.label === 'ALL';
        return isAll && max.value.isPositive ? max.value : spendableBalance;
    }
    const fromAsset = get(fromAssetAtom);
    const swapMode = get(swapModeAtom);
    const slippage = get(slippageAtom);
    const fee = get(feeAmountAtom);
    const isFromFeeAsset = fromAsset.name === fromAsset.feeAsset.name;
    const balanceMinusFee = isFromFeeAsset
        ? spendableBalance.sub(fee).clampLowerZero()
        : spendableBalance;
    if (swapMode === 'ExactOut') {
        return balanceMinusFee.mul(1 - slippage / 100);
    }
    return balanceMinusFee.isPositive ? balanceMinusFee : spendableBalance;
});
export default fromTotalBalanceAtom;
